<script lang="ts">
  import {appName} from "src/partials/state"
  import MediaVideo from "src/partials/MediaVideo.svelte"
  import Button from "src/partials/Button.svelte"
  import Modal from "src/partials/Modal.svelte"

  export let setStage

  let media

  const next = () => setStage("keys")

  const openMedia = url => {
    media = url
  }

  const closeMedia = () => {
    media = null
  }
</script>

<div class="flex gap-3">
  <p
    class="-ml-1 -mt-2 flex h-12 w-12 items-center justify-center rounded-full bg-neutral-700 text-lg">
    1/4
  </p>
  <p class="text-2xl font-bold">New to Nostr?</p>
</div>
<p class="sm:hidden">
  Take a moment to get acquainted with {appName} — or skip straight to account setup.
</p>
<p class="hidden sm:block">
  Take a moment to get acquainted with the protocol — or skip straight to account setup.
</p>

<p>
  When you’re ready, click below and we’ll guide you through the process of creating an account.
</p>
<Button class="btn btn-accent text-center" on:click={next}>Let's go!</Button>

{#if media}
  <Modal onEscape={closeMedia}>
    <MediaVideo url={media || ""} />
  </Modal>
{/if}
